export default {
    listagem: {
        titulo_pagina: 'Lista de Tipos',
        empty: 'No se encontró ningún valor para este tipo',
        novo: 'Crear Nuevo Tipo',
        habilitado: 'Capaz',
        desabilitado: 'Desactivado',
        table: {
            empty: 'No se encontró ningún tipo',
            nome: 'Nombre',
            codigo: 'Código',
            editar: 'Editar',
            valores: 'Valores'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Tipo',
            editar: 'Editar Tipo'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código de Tipo'
            },
            nome: {
                label: 'Nombre',
                description: 'Nombre de Tipo'
            },
            status: {
                label: 'Estado',
                description: 'Tipo el estado activo o inactivo'
            },
            botao_salvar : 'Guardar Tipo'
        },
        create: {
            success: '¡Tipo creado con éxito!',
            error: '¡Error al crear el tipo!'
        },
        update: {
            success: '¡Tipo editado con éxito!',
            error: '¡Error al editar Tipo!'
        }
    },
    value: {
        form: {
            titulo_pagina: {
                criar: 'Crear Nuevo Tipo',
                editar: 'Editar Tipo'
            },
            fields: {
                codigo: {
                    label: 'Código',
                    description: 'Código de Tipo'
                },
                nome: {
                    label: 'Nombre',
                    description: 'Nombre de Tipo'
                },
                description: {
                    label: 'Descripción',
                    description: 'Descripción y/o Explicación del Valor'
                },
                status: {
                    label: 'Estado',
                    description: 'Tipo el estado activo o inactivo'
                },
                botao_salvar : 'Guardar Tipo'
            },
            create: {
                success: '¡Tipo creado con éxito!',
                error: '¡Error al crear el tipo!'
            },
            update: {
                success: '¡Tipo editado con éxito!',
                error: '¡Error al editar Tipo!'
            }
        }
    }
}
